import { Component, OnInit, OnDestroy } from '@angular/core';
import { SearchService } from '../../services/search-service.service';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-where-to-stay',
  templateUrl: './where-to-stay.component.html',
  styleUrls: ['./where-to-stay.component.scss'],
})
export class WheretostayComponent implements OnInit, OnDestroy {
  allImages: string[] = [];
  randomImages: string[] = [];
  accommodations: any[] = [];
  readonly fallbackImage = 'assets/images/NoImage.jpg';

  private destroy$ = new Subject<void>();

  constructor(private router: Router, private searchService: SearchService) {}

  ngOnInit() {
    this.getAccommodationList();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getAccommodationList() {
    this.searchService
      .planYourVisitSearchListing('ACCOMM', '', '', '', '', 1)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          const allImages = response?.products?.map((item: any) => item.productImage) || [];
          // Seeded (per-day) shuffle instead of Math.random() on every render.
          // Keeps the featured 4 images stable within a day so LCP/CLS stay
          // measurable and consistent, while still rotating day to day.
          this.accommodations = this.seededShuffle(allImages, this.getDaySeed()).slice(0, 4);
        },
        error: (error) => {
          console.error('API Error:', error);
        },
      });
  }

  trackByImage(index: number, img: string): string {
    return img || index.toString();
  }

  onImageError(event: Event): void {
    const target = event.target as HTMLImageElement;
    if (target.src.indexOf(this.fallbackImage) === -1) {
      target.src = this.fallbackImage;
    }
  }

  btnClick = () => {
    this.router.navigateByUrl('/planyourvisit/wheretostay');
  };

  private getDaySeed(): number {
    const now = new Date();
    return now.getFullYear() * 10000 + (now.getMonth() + 1) * 100 + now.getDate();
  }

  private seededShuffle<T>(array: T[], seed: number): T[] {
    const result = [...array];
    let currentSeed = seed;
    const random = () => {
      currentSeed = (currentSeed * 9301 + 49297) % 233280;
      return currentSeed / 233280;
    };
    for (let i = result.length - 1; i > 0; i--) {
      const j = Math.floor(random() * (i + 1));
      [result[i], result[j]] = [result[j], result[i]];
    }
    return result;
  }
}
